
import { useState } from 'react';

// Default call-to-action text - matches what's in the email template
const DEFAULT_CTA_TEXT = "Trykk på knappen under for å gå til siden for innsending på våre nettsider eller svar på denne e-posten. Vennligst inkluder navn, tittel og tilknytning/arbeidsgiver i svaret.";

const STORAGE_KEY = 'briefr_cta_text';

export const useCallToActionText = () => {
  // Initialize from localStorage or use default
  const [ctaText, setCtaText] = useState(() => {
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored || DEFAULT_CTA_TEXT;
    }
    return DEFAULT_CTA_TEXT;
  });

  // Function to update the CTA text and persist to localStorage
  const updateCtaText = (newText: string) => {
    const text = newText || DEFAULT_CTA_TEXT;
    setCtaText(text);
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, text);
    }
  };

  // Reset to default text
  const resetToDefault = () => {
    setCtaText(DEFAULT_CTA_TEXT);
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, DEFAULT_CTA_TEXT);
    }
  };

  return {
    ctaText,
    updateCtaText,
    resetToDefault,
    DEFAULT_CTA_TEXT
  };
};
